<template>
<div>
  <el-form ref="editForm" label-width="100px" :model="editJson" :rules="rules">
    <el-form-item label="关键字" prop="content">
      <el-input v-model="editJson.content"></el-input>
    </el-form-item>
    <el-form-item label="设置类型" prop="settingType">
      <common-select v-model="editJson.settingType" :url="$api.Identity.BasicData.all" :filterData="filterData" :params="{ItemType:'SettingType'}"  ajaxMethod="get" optLabel="itemValue" optValue="itemKey"></common-select>
    </el-form-item>
    <el-form-item label="状态" prop="status">
      <el-switch v-model="editJson.status" :inactive-value="0" :active-value="1"></el-switch>
      &nbsp;&nbsp;{{ editJson.status == 1 ? "启用": '停用' }}
    </el-form-item>
    <el-form-item label-width="0" class="atb-no-margin">
        <div class="atb-text-right">
        <!-- 保存 -->
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
        <!-- 取消 -->
        <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
        </div>
  </el-form-item>
  </el-form>
</div>

</template>
<script>
import editMixin from '@/mixins/edit.mixin'
export default {
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      id: 'id',
      rules: {
        content: [
          { required: true, message: '请输入关键字', trigger: 'blur' },
          { max: 64, message: '最多64个字符', trigger: 'blur' }
        ],
        settingType: [
          { required: true, message: '请选择设置类型', trigger: 'change' },
        ]
      },
      addApi: this.$api.Identity.CustomSetting.create,
      editApi: this.$api.Identity.CustomSetting.update,
      editMethod:'put',
    }
  },
  mounted(){
    if(!this.isEdit){
      this.$set(this.editJson,'status', 1);
    }else{
      this.$set(this.editJson,'settingType',this.editJson.settingType.toString());
    }
  },
  methods:{
      filterData(res){
       return res.data&&res.data.rows||[];
     },
  }
}
</script>
